<template>
  <div class="field xr-page-select-div">
    <div class="choose-input field-container"   @mouseover="mouseoverMethod()" @mouseout="mouseoutMethod()">

      <slot name="page-select-name"></slot>
      <slot name="page-select-id"></slot>

      <div class="page-select-icon" @click="pageSelect()">
        <i class="wk wk-page-select"></i>
      </div>

      <div class="choose-input-clean" v-show="showClean"  @click="cleanPageSelect()">
        <i class="wk wk-cancel1"></i>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "index",
        props: ['selectName'],
        data(){
          return {
            showClean: false
          }
        },
        methods: {
          //进入方法
          mouseoverMethod(){
            if(this.selectName){
              this.showClean = true;
            }
          },
          //出去方法
          mouseoutMethod(){
            this.showClean = false;
          },
          //清楚内容
          cleanPageSelect(){
            this.$emit('cleanPageSelect'); //通知父组件改变。
          },
          //点击
          pageSelect(){
            this.$emit('pageSelect'); //通知父组件改变。
          }
        }
    }
</script>

<style scoped>

  .field{
    height: 100%;
    overflow: hidden;
    font-size: 12px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .choose-input{
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    position: relative;
    min-height: 30px;
  }

  .page-select-input{
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-right: 38px;
    padding-left: 8px;
    color: rgba(0,0,0,.65);
    font-family: Microsoft YaHei,serif;
    font-size: 12px;
    height: 100%;
    background-color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: 30px;
  }

  .page-select-icon{
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 100;
    width: 30px;
    margin-left: -30px;
    background-size: 14px;
  }

  .choose-input-clean{
    min-height: 30px;
    position: absolute;
    right: 28px;
    width: 20px;
    height: 100%;
    cursor: pointer;
  }

  .choose-input-clean i{
    font-size: 12px;
  }

  .content-wrapper{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>



// WEBPACK FOOTER //
// src/components/XrPageSelect/index.vue